import { ModuleConfig } from '@/core/module';
import { routes } from './routes';
import { useTermsAndConditionsStore } from './stores/termsAndConditionsStore';

export const TermsAndConditionsModule: ModuleConfig = {
  name: 'termsandconditions',
  routes: routes,
  stores: {
    termsAndConditions: useTermsAndConditionsStore
  },
  initialize: () => {
    console.log('Terms and Conditions module initialized');
  },
  cleanup: () => {
    console.log('Terms and Conditions module cleanup');
  }
};
